import React from 'react';
import SignatureSelection from 'ui/sections/notarize/pages/SignatureSelection';
import { NotarizationStatus } from 'utils/enums';

export default class SpouseSignatureSelection extends SignatureSelection {
  static forSpouse = true;
  static notarizationSection = NotarizationStatus.SIGNATURE_CREATION_SPOUSE;
}
